var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAuthenticated
    ? _c("div", { staticClass: "gobot-widget" }, [
        _c(
          "button",
          {
            staticClass: "gobot-launcher",
            attrs: {
              "aria-label": "Open feedback widget",
              "aria-expanded": _vm.isOpen
            },
            on: { click: _vm.togglePopup }
          },
          [
            _c("img", {
              staticClass: "gobot-icon",
              attrs: { src: "/img/icons/gobot.png", alt: "" }
            })
          ]
        ),
        _vm.isOpen
          ? _c(
              "div",
              {
                ref: "popup",
                staticClass: "gobot-popup",
                attrs: {
                  role: "dialog",
                  "aria-labelledby": "gobot-title",
                  "aria-modal": "true"
                }
              },
              [
                _c("div", { staticClass: "gobot-header" }, [
                  _c(
                    "h3",
                    {
                      staticClass: "gobot-title",
                      attrs: { id: "gobot-title" }
                    },
                    [_vm._v("Gobot")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "gobot-close",
                      attrs: { "aria-label": "Close feedback widget" },
                      on: { click: _vm.closePopup }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("div", { staticClass: "gobot-body" }, [
                  _vm.submitted
                    ? _c("div", { staticClass: "gobot-success" }, [
                        _c("p", [
                          _vm._v("Thanks! I'll pass that along right away. 🤘")
                        ])
                      ])
                    : _c("div", [
                        _c("p", { staticClass: "gobot-intro" }, [
                          _vm._v(
                            " Hi! I'm Gobot. I can pass along any feedback, bug reports, or feature requests to the Gobo team. What would you like me to tell them? "
                          )
                        ]),
                        _c("div", { staticClass: "gobot-form" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.message,
                                expression: "message"
                              }
                            ],
                            ref: "textarea",
                            staticClass: "gobot-textarea",
                            attrs: {
                              placeholder: "Type your message here...",
                              rows: "4",
                              disabled: _vm.submitting
                            },
                            domProps: { value: _vm.message },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.message = $event.target.value
                              }
                            }
                          }),
                          _vm.errorMessage
                            ? _c("div", { staticClass: "gobot-error" }, [
                                _vm._v(" " + _vm._s(_vm.errorMessage) + " ")
                              ])
                            : _vm._e(),
                          _c(
                            "button",
                            {
                              staticClass: "gobot-submit",
                              attrs: {
                                disabled: !_vm.message.trim() || _vm.submitting
                              },
                              on: { click: _vm.submitFeedback }
                            },
                            [
                              _vm.submitting
                                ? _c("span", [_vm._v("Sending...")])
                                : _c("span", [_vm._v("Send to Gobo")])
                            ]
                          )
                        ])
                      ])
                ])
              ]
            )
          : _vm._e(),
        _vm.isOpen
          ? _c("div", {
              staticClass: "gobot-overlay",
              on: { click: _vm.closePopup }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }